import { useEffect } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { AppRoutes } from '@/routes'
import { ScrollToTop } from '@/components/layout/ScrollToTop'
import { StoreGateProvider } from '@/contexts/StoreGateContext'
import { useAuthStore } from '@/stores/authStore'
import { BRAND_GOLD } from '@/lib/brand'

function App() {
  const initAuth = useAuthStore((s) => s.initAuth)

  useEffect(() => {
    const unsubscribe = initAuth()
    return unsubscribe
  }, [initAuth])

  return (
    <BrowserRouter>
      <StoreGateProvider>
        <ScrollToTop />
        <AppRoutes />
      </StoreGateProvider>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: BRAND_GOLD.ivory,
            color: '#3f3f46',
            border: `1px solid ${BRAND_GOLD.parchment}`,
            borderRadius: '12px',
            boxShadow: '0 8px 32px rgba(122, 92, 46, 0.12)',
          },
          success: {
            iconTheme: { primary: BRAND_GOLD.primary, secondary: BRAND_GOLD.white },
          },
        }}
      />
    </BrowserRouter>
  )
}

export default App
